import { useParams } from 'react-router';
import { useGetComponentDetailsQuery } from '../../../features/courses/coursesApi';
import { useUserProfileQuery } from '../../../features/auth/authApi';
import React from 'react';
import { Col, Row, Space } from 'antd';
import PageTitle from '../../common/PageTitle';
import ComponentDescription from '../components/componentDescription';
import {
    ComponentFileResource,
    ComponentLinkResources,
    ComponentNotebookResource,
} from '../components/componentResources';

const ComponentDetailPage = () => {
    const { componentId } = useParams();
    const { data: user } = useUserProfileQuery('userDetails');
    const { data: component, isFetching } =
        useGetComponentDetailsQuery(componentId);

    if (isFetching) {
        return <div>Loading...</div>;
    }

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <PageTitle title={component.title} />

            <ComponentDescription component={component} />
            <Row gutter={8}>
                <Col span={12}>
                    <ComponentLinkResources component={component} user={user} />
                </Col>
                <Col span={12}>
                    <ComponentFileResource component={component} user={user} />
                </Col>
            </Row>
            <Row>
                <ComponentNotebookResource component={component}/>
            </Row>
        </Space>
    );
};

export default ComponentDetailPage;
